import Controller from './close_when_clicked_outside_controller';

export default class extends Controller {
  static targets = ['selectedOptions', 'option'];
  static values = { placeholder: String };

  connect() {
    super.connect();
    this.updatePlaceholder();
  }

  toggle(event) {
    this._opened = this.#ignoreToggle(event) ? this._opened : !this._opened;
  }

  updatePlaceholder() {
    const selectedOptions = this.optionTargets.filter(this.#withOptionSelected);
    const selectedNames = selectedOptions.map(this.#nameForOption);
    const placeholder = selectedNames.join('<span class="ms-separator">, </span>');

    this.selectedOptionsTarget.innerHTML = placeholder || this.placeholderValue;
  }

  get _opened() {
    return this.element.classList.contains('multi-select--open');
  }

  set _opened(value) {
    this.element.classList.toggle('multi-select--open', value);
  }

  #withOptionSelected(option) {
    return option.querySelector('input[type="checkbox"]:checked');
  }

  #nameForOption(option) {
    return option.querySelector('label').innerHTML;
  }

  #ignoreToggle(event) {
    return event.target?.closest('.multi-select--cancel');
  }
}
